<template>
  <!-- 顶部导航 -->
  <div class="pa z-100">
      <div class="pa topBarIcon1" @click="toggleDropdown">
          <img src="/imgs/topBarIcon1.png">
      </div>
      <div v-if="isOpen" class="dropdown-items">
        <div 
          v-for="(item, index) in items" 
          :key="index" 
          @click="selectItem(item)"
          class="dropdown-item"
        >
          {{ item }}
        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'top-bar',
  components: {},
  props: ['dataHeader'],
  data() {
    return {
      isOpen: false,
      selected: null,
      items: ['园区整体监控', '数据中心监控', '合规监管', '运维监控'],
    }
  },
  created () {

  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectItem(item) {
      this.selected = item;
      this.isOpen = false; // 选择后关闭下拉列表
      
      let path = '';
      switch (item) {
        case '园区整体监控':
          path = '/overall';
          break;
        case '数据中心监控':
          path = '/dc';
          break;
        case '合规监管':
          path = '/compliance';
          break;
        case '运维监控':
          path = '/monitoring';
          break;
      }
      
      // 使用Vue Router进行页面跳转，并在导航成功后强制刷新页面
      this.$router.push(path).then(() => {
        window.location.reload(); // 强制刷新页面
      }).catch(err => {
        // 忽略导航重复的错误
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    }
  }
}
</script>

<style lang="scss">

.topBarIcon1{
  width:26px;
  height:23px; 
  top:15px; 
  left:40px;
}
.topBarIcon1 img{
  width:26px;
  height:23px;
  cursor: pointer; 
}

.dropdown-items {
  position: absolute;
    width: 130px;
    height: 163px;
    top: 47px;
    left: 40px;
    right: 0;
    background: url(/imgs/topBarIcon1Select.png) no-repeat;
    z-index: 110;
    overflow: scroll;
    background-size: 130px 163px;
    padding-top: 2px;
}

.dropdown-item {
  padding: 10px 15px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #052A37;

}

.topBarIcon2{
  width:24px;
  height:24px;
  top:15px; 
  left:100px;
}
.topBarIcon2 img{
  width:24px;
  height:24px;
  cursor: pointer;
}

.blk-title{
  font-size: 35px;
  letter-spacing: 5px;
  text-align: left;
  font-weight: 500;
  line-height: 90px;
  width: 100%;
  text-align: center;
  color: #19ECFF;
}
.blk-linklogo{
  float: right;
  margin: 47px 22px;
}
.blk-linklogo img{
  display: inline-block;
  width: 42px;
  height: 42px;
  border-radius: 100px;
  margin-left: 28px;
  cursor: pointer;
}

.blk-nowdate{
  position: absolute;
  top:0;
  right: 0;
  margin-top: 20px;
  margin-right: 35px;
  font-size:18px;
  letter-spacing: 2px;
  color: #fff;
}


</style>
